<template>
  <div>
    <button @click="toggleSidebar()">
      <faBarsIcon class="w-5 fill-primary/80 hover:fill-primary" />
    </button>
    <Teleport v-if="sidebarVisible" to="#appBody">
      <div
        class="z-50 absolute top-0 end-0 w-screen h-screen opacity-50 bg-gray-500 dark:bg-slate-800 backdrop-blur-md"
        @click="toggleSidebar(false)"
      ></div>
      <div class="z-[60] absolute top-0 start-0 w-2/3 h-screen flex gap-x-4 items-start">
        <div class="flex-1 h-full bg-white">
          <MobileMenuView />
        </div>
        <button class="group size-12 rounded-full flex justify-center items center">
          <faTimes class="w-4 group-hover:scale-125 fill-white"></faTimes>
        </button>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import faTimes from '@/assets/icons/faTimes.svg?component'
import faBarsIcon from '@/assets/icons/faBars.svg?component'
import { useToggle } from '@vueuse/core'
import { watch } from 'vue'
import MobileMenuView from '@/components/headers/mobile_menu/index.vue'

const [sidebarVisible, toggleSidebar] = useToggle()

watch(sidebarVisible, (isVisible) => {
  document.body.style.overflow = isVisible ? 'hidden' : 'inherit'
})
</script>

<style lang="scss" scoped></style>
